interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm transition-colors";

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:border-primary-400 hover:text-primary-600`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${btnBase} ${
            page === current
              ? "bg-primary-500 font-bold text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:border-primary-400 hover:text-primary-600`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}